import styled from 'styled-components';

export const Title = styled.h1`
    max-width: 230px;
    margin: 1rem 0;
    color: #FFF;
    font-size: 20px;

    @media(max-width: 767px){
        margin: 1rem auto;
    }
`;
export const BottomTitle = styled.h2`
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    text-align: center;
`;
export const TitleMarca = styled.span`
    font-size: 22px;
    color: #FFF;
    font-weight: 700;
    padding-bottom: 16px;
`
export const NameMarca = styled.span`
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
`
export const Textdesconto = styled.span`
    font-size: 18px;
    color: #282828;
    font-weight: 700;
    font-style: italic;
    padding:0px 12px;
`